import { oloApi } from '@/lib/apiClient'
import { oloUrls } from '@/lib/urlBuilder'

export interface GiftCardBalanceResponse {
	balance: number // cents
}

export async function getGiftCardBalance(ref: string, code: string): Promise<number> {
	const url = oloUrls.giftCardBalance(ref, code)
	const response = await oloApi.get<GiftCardBalanceResponse>(url)
	return response.balance
}
